import loadable from 'components/dynamic-import';

const ConnectedStreamerWelcome = loadable(() => import('./ConnectedStreamerWelcome'), false);

export { ConnectedStreamerWelcome };
